function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from '@ori-ui/components';
import { Visibility, VisibilityOff } from '@ori-ui/icons';
import { InputAdornment, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
var VisibilityOffStyled = styled(VisibilityOff)(function(param) {
    var theme = param.theme;
    return {
        fontSize: '35px',
        fill: theme.palette.default.main
    };
});
var VisibilityStyled = styled(Visibility)(function(param) {
    var theme = param.theme;
    return {
        fontSize: '35px',
        fill: theme.palette.default.main
    };
});
var StyledIconButton = styled(IconButton)(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(0)
    };
});
export var PasswordToggle = function(props) {
    var isShowPassword = props.isShowPassword, setPasswordVisible = props.setPasswordVisible;
    var getTestIdProps = useTestId().getTestIdProps;
    var handleClick = function() {
        return setPasswordVisible(!isShowPassword);
    };
    var icon = isShowPassword ? /*#__PURE__*/ _jsx(VisibilityOffStyled, _object_spread({}, getTestIdProps('icon-visibilityOff'))) : /*#__PURE__*/ _jsx(VisibilityStyled, _object_spread({}, getTestIdProps('icon-visibilityOn')));
    return /*#__PURE__*/ _jsx(InputAdornment, {
        position: "end",
        children: /*#__PURE__*/ _jsx(StyledIconButton, {
            variant: "text",
            color: "default",
            onClick: handleClick,
            children: icon
        })
    });
};
